import { useState, useEffect } from 'react';
import { t, setLocale as setLocaleUtil, getLocale } from '../utils/translations';

export const useTranslation = () => {
    const [locale, setLocaleState] = useState(getLocale());

    useEffect(() => {
        const handleLocaleChange = () => {
            setLocaleState(getLocale());
        };

        window.addEventListener('localechange', handleLocaleChange);
        return () => window.removeEventListener('localechange', handleLocaleChange);
    }, []);

    return {
        t: (key) => t(key, locale),
        locale,
        setLocale: (newLocale) => {
            setLocaleUtil(newLocale);
            setLocaleState(newLocale);
        },
    };
};

